<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">註冊</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<div class="d-flex justify-content-center h-100">
					<div class="card form-box">
						<div class="card-header">
							<h3 class="item-title">註冊</h3>
						</div>
						<div class="card-body">
							<form>
								<div class="form-group input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<i style="min-width: 20px" class="fa fa-user-alt"></i>
										</span>
									</div>
									<input v-model="loginId" name="id" class="form-control" placeholder="帳號" type="text">
								</div>
								<div class="form-group input-group">
									<div class="input-group-prepend">
										<span class="input-group-text"> <i style="min-width: 20px" class="fa fa-lock"></i> </span>
									</div>
									<input v-model="pasuwado" class="form-control" placeholder="密碼" type="password">
								</div>
								<div class="form-group input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<i style="min-width: 20px" class="fa fa-lock"></i>
										</span>
									</div>
									<input v-model="pasuwado2" class="form-control" placeholder="確認密碼" type="password">
								</div>
								<div class="form-group input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<i style="min-width: 20px" class="fa fa-signature"></i>
										</span>
									</div>
									<input v-model="nickName" name="nickName" class="form-control" placeholder="暱稱" type="text">
								</div>
								<div class="alert alert-danger" role="alert" v-if="error != ''">
									{{error}}
								</div>
								<div class="form-group">
									<button @click="regist()" type="button" class="pcbtn btn-block"> 完成 </button>
								</div>
								<p class="text-center">已有帳號?
									<router-link :to="{ name: 'Login'}" class="mx-3">
										登入
									</router-link>
								</p>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
	name: 'Register',
	data() {
		return {			
			"loginId":"",
			"pasuwado":"",
			"pasuwado2":"",
			"nickName":"",
			"error": ""
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '註冊',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki'
	},
	methods: {
		regist: function() {
			var self = this;
			if (self.loginId == "") {
				self.error = "請輸入帳號";
				return;
			}
			if (!/^[A-Za-z0-9]*$/.test(self.loginId)) {
				self.error = "帳號需為英文/數字";
				return;
			}
			if (self.loginId.length < 6) {
				self.error = "帳號需大於6碼";
				return;
			}
			if (self.pasuwado == "") {
				self.error = "請輸入密碼";
				return;
			}
			if (self.pasuwado2 == "") {
				self.error = "請輸入確認密碼";
				return;
			}
			if (self.pasuwado2 != self.pasuwado) {
				self.error = "密碼不一致";
				return;
			}
			self.error = "";
			//var url = "http://localhost/project/php/AddMember.php";
			var url = "/static/php/AddMember.php";
			var data = { "loginId": self.loginId, "pasuwado": self.pasuwado, "pasuwado2": self.pasuwado2, "nickName": self.nickName };
			$.ajax({
				type: "POST",
				url: url,
				data: data,
				success: function(data) {
					if (data) {
						var rsp = JSON.parse(data);
						if (rsp.Code == "1") {
							self.error = "帳號重複";
						}else if (rsp.Code == "2") {
							self.error = "密碼不一致";
						} else if (rsp.Code == "200") {
							self.$router.push("Login");
						}	
					} else {
						self.error = "伺服器錯誤";
					}
				},
				error: function(res) {
					this.error = res;
				}
			});
		},
		mouseOver: function(item, index) {

		}
	},
	created: function() {

	},
	computed: {

	},
	mounted: function() {

	}
}

</script>
<style type="text/css">
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css'

</style>
